import {
  Button,
  Flex,
  Link,
  Tag,
  Text,
  Tooltip,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ProductStatsItem } from '../../helpers/report.types';
import { ENGINEERS_PREVIEW_LIMIT, normalizeEngineersList } from './utils';

export const EngineersCell = ({
  value,
}: {
  value: ProductStatsItem['engineers'];
}) => {
  const items = normalizeEngineersList(value);
  const [showAll, setShowAll] = useState(false);

  if (items.length === 0) {
    return (
      <Text fontSize="sm" fontFamily="heading" color="text.secondary">
        -
      </Text>
    );
  }

  const limit = ENGINEERS_PREVIEW_LIMIT;
  const hasMore = items.length > limit;
  const visible = showAll || !hasMore ? items : items.slice(0, limit);
  const hiddenCount = items.length - limit;

  return (
    <Flex direction="column" align="flex-start" gap={2} w="full">
      <Wrap spacing={1.5} rowGap={1.5} w="full" align="center">
        {visible.map((name, i) => (
          <WrapItem key={`${name}-${i}`}>
            <Tooltip label={name} hasArrow isDisabled={name.length < 28}>
              <Tag
                size="sm"
                variant="subtle"
                colorScheme="gray"
                fontFamily="heading"
                fontWeight="medium"
                fontSize="xs"
                px={2}
                py={0.5}
                borderRadius="md"
                maxW="100%"
                whiteSpace="normal"
                wordBreak="break-word"
                cursor="pointer"
              >
                <Link
                  as={RouterLink}
                  to={`/contributors/${encodeURIComponent(name)}`}
                  color="inherit"
                  textDecoration="none"
                  cursor="pointer"
                  _hover={{ color: 'inherit', textDecoration: 'none' }}
                  _active={{ color: 'inherit' }}
                  _visited={{ color: 'inherit' }}
                >
                  {name}
                </Link>
              </Tag>
            </Tooltip>
          </WrapItem>
        ))}
      </Wrap>
      {hasMore && (
        <Button
          variant="link"
          size="sm"
          fontWeight="medium"
          h="auto"
          minH={0}
          py={0}
          onClick={() => setShowAll((v) => !v)}
        >
          {showAll ? 'Show less' : `Show ${hiddenCount} more`}
        </Button>
      )}
    </Flex>
  );
};
